/* eslint-disable camelcase */
import React from 'react';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Flex,
  Text,
  icons,
  RoundImg,
} from 'web-styled';

const mapState = state => ({
  pro: coreSelectors.getClientPro(state),
});

const Trainer = () => {
  const { pro } = useSelector(mapState, shallowEqual);
  const profile = pro?.user_profile || {};
  return (
    <Flex align="center" spacing={10}>
      <Text color="rgba(255, 255, 255, 0.5)">
        {profile.user_type}
      </Text>
      <Flex align="center" spacing={15}>
        <Text color="#fff">
          {`${profile.first_name} ${profile.last_name}`}
        </Text>
        <RoundImg
          alt=""
          size="53px"
          src={profile.avatar?.thumb?.url || icons.clientAvatarPlaceHolder}
        />
      </Flex>
    </Flex>
  );
};

export default Trainer;
